import React from 'react';
import styled, { css } from 'styled-components';
import { GLOBALS } from '../../utils/globals';
import SeperatorBlue from '../../svg/SeperatorBlau.svg';
import SeperatorYellow from '../../svg/SeperatorGelb.svg';

const SeperatorStyles = css`
  margin: 0 0 var(--distance-m);
  width: 100%;
  height: auto;
`;

const StyledSeperatorBlue = styled(SeperatorBlue)`
  ${SeperatorStyles}
`;
const StyledSeperatorYellow = styled(SeperatorYellow)`
  ${SeperatorStyles}
`;

const Seperator = () => 
  GLOBALS.theme === 'yellow' ? <StyledSeperatorYellow /> : <StyledSeperatorBlue />;
export default Seperator;
